// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"20":"c08f3f89","204":"ef3960aa","704":"9d666f0e"}[chunkId] + ".js";
};